module.exports = __webpack_public_path__ + "img/link-account.5ed0cc18.png";